import React, { useEffect, useState } from "react";
import ic_job_creation_success from "../img/ic_job_creation_success.png";
import "../css/Create_customer_popup.css";
import axios from "axios";
import ic_user_name from "../img/ic_user_name.png";
import ic_user_phone from "../img/ic_user_phone.png";
import Common_loader from "../components/Common_loader";

function Fleet_registration_popup(props) {

    
    const [showHideMakeState, setShowHideMakeState] = useState(false);
    const [showHideModelState, setShowHideModelState] = useState(false);

    const [modelArrayState, setModelArrayState] = useState(null);
    const [makeArrayState, setMakeArrayState] = useState(null);

    const { userName, accountNumber, mobileNumber, closePopupAddFleet, closePopupAfterSuccessfulFleetCreation, setErrorMessage } = props;

    const [isCallingAPI, setIsCallingAPI] = useState(false);


    let initialUserObject = {
        account: accountNumber,
        plate_no: "",
        chassis_no: "",
        model: "Select model",
        make: "Select make",
        year: "",
    }

    const [userObjectState, setUserObjectState] = useState(initialUserObject);

    const addFleet = () => {

        let objectToSendToAPI = {
            account: userObjectState.account,
            plate_no: userObjectState.plate_no,
            chassis_no: userObjectState.chassis_no,
            model: userObjectState.model,
            make: userObjectState.make,
            year: userObjectState.year,
        }

        if (objectToSendToAPI.account.length == 0) {

            setErrorMessage("please select a customer first")

        } else if (objectToSendToAPI.plate_no.length == 0) {
            setErrorMessage("Please enter plate number")
        } else if (objectToSendToAPI.chassis_no.length == 0) {
            setErrorMessage("Please enter chassis number")
        } else if (objectToSendToAPI.model.length == 0) {
            setErrorMessage("Please enter model")
        } else if (objectToSendToAPI.make.length == 0) {
            setErrorMessage("Please enter make")
        } else if (objectToSendToAPI.year.length == 0) {
            setErrorMessage("Please enter year")
        } else {
            setIsCallingAPI(true)

            console.log(" calling API objectToSendToAPI is ", objectToSendToAPI)
            axios.post(`${process.env.REACT_APP_BACK_END_BASE_URL}/Fleet_registration`, [objectToSendToAPI]).then((res) => {

                setIsCallingAPI(false)

                console.log("customer creation res is ", res)
                if (res.data.result == "Saved") {
                    closePopupAfterSuccessfulFleetCreation();
                }

            }).catch((err) => {
                setIsCallingAPI(false)
                console.log("err is ", err)
                setErrorMessage("Something went wrong, Please try later")
            })
        }

    }

    const handleInput = (e) => {
        setUserObjectState(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const handleDropDownClickModel = (value) => {
        setUserObjectState(prev => ({ ...prev, model: value }))
        showHideModelDropDown();
    }

    const handleDropDownClickMake = (value) => {
        setUserObjectState(prev => ({ ...prev, make: value }))
        showHideMakeDropDown()
    }

    const getModelList = () => {

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/model/12100001`).then((res) => {
            setModelArrayState(res.data.jsont);
        }).catch((err) => {
            console.log("err ", err);
        })
    }

    const getMakeList = () => {

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/make/12100001`).then((res) => {
            setMakeArrayState(res.data.jsont);
        }).catch((err) => {
            console.log("err ", err);
        })
    }

    const showHideModelDropDown = () => {
        setShowHideModelState(prev => !prev);
    }

    const showHideMakeDropDown = ()=>{
        setShowHideMakeState(prev => !prev);
    }

    useEffect(() => {

        getModelList();
        getMakeList();

    }, [])

    return (
        <div className="Create_customer_popup_root_container">
            <h6>Add Fleet</h6>

            <div className="Add_Fleet_account_label_container mt-4">
                <label className="Add_Fleet_account_label"><img src={ic_user_name} className="me-3" />{userName}</label>
                <label className="Add_Fleet_account_label mt-4"><img src={ic_user_phone} className="me-3" />{mobileNumber}</label>
            </div>

            <div className="Create_customer_popup_root_container_input_field_containers mt-4">
                <label>Plate number</label>
                <input type="text" name="plate_no" className="CreateNewJob_Add_service_popup_type_box mt-1" onChange={(e) => handleInput(e)} />
                <label className="mt-4">Chassis number</label>
                <input type="text" name="chassis_no" className="CreateNewJob_Add_service_popup_type_box mt-1" onChange={(e) => handleInput(e)} />

                <label className="mt-4">Model</label>
                <div className="common-dropdown-wrapper">
                    <input onClick={showHideModelDropDown} type="text" name="model" className="CreateNewJob_Add_service_popup_type_box mt-1" value={userObjectState.model} />

                    {
                        showHideModelState &&
                        <div className="common-DropDown-container">
                            {
                                modelArrayState != null ?
                                    modelArrayState.map((item) => {
                                        return (
                                            <div onClick={() => handleDropDownClickModel(item.model)} className="p-2">{item.model}</div>
                                        )
                                    })
                                    :
                                    null
                            }
                        </div>
                    }

                </div>

                <label className="mt-4">Make</label>

                <div className="common-dropdown-wrapper">
                    <input onClick={showHideMakeDropDown} type="text" name="make" className="CreateNewJob_Add_service_popup_type_box mt-1" value={userObjectState.make} />
                    {
                        showHideMakeState &&
                        <div className="common-DropDown-container">
                            {
                                makeArrayState != null ?
                                    makeArrayState.map((item) => {
                                        return (
                                            <div onClick={() => handleDropDownClickMake(item.make)} className="p-2">{item.make}</div>
                                        )
                                    })
                                    :
                                    null
                            }
                        </div>
                    }
                </div>

                <label className="mt-4">Year</label>
                <input type="number" name="year" className="CreateNewJob_Add_service_popup_type_box CreateNewJob_year_input_box mt-1" onChange={(e) => handleInput(e)} />

            </div>

            <div className="Create_customer_popup_button_container">
                <button className="common_close_button mt-4" onClick={() => closePopupAddFleet()}>Cancel</button>
                <button className="common_grey_button mt-4" onClick={() => addFleet()}>Add</button>
            </div>


            {
                isCallingAPI &&
                <Common_loader />
            }

        </div>
    )
}

export default Fleet_registration_popup;